export { default as Img200 } from './processed/200/Pathfinder.jpg';
export { default as Img400 } from './processed/400/Pathfinder.jpg';
export { default as Imgthumb } from './processed/thumb/Pathfinder.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Pathfinder.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Pathfinder.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      21,
      182,
      186
    ],
    "_population": 636,
    "_hsl": [
      0.5040404040404041,
      0.7971014492753622,
      0.40588235294117647
    ]
  },
  "LightVibrant": {
    "_rgb": [
      153,
      213,
      219
    ],
    "_population": 3195,
    "_hsl": [
      0.5151515151515151,
      0.47826086956521735,
      0.7294117647058823
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      8,
      107,
      117
    ],
    "_population": 2720,
    "_hsl": [
      0.5152905198776758,
      0.872,
      0.24509803921568626
    ]
  },
  "Muted": {
    "_rgb": [
      97,
      143,
      134
    ],
    "_population": 330,
    "_hsl": [
      0.4673913043478261,
      0.1916666666666667,
      0.47058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      138,
      186,
      195
    ],
    "_population": 36,
    "_hsl": [
      0.5263157894736842,
      0.32203389830508466,
      0.6529411764705881
    ]
  },
  "DarkMuted": {
    "_rgb": [
      91,
      93,
      63
    ],
    "_population": 309,
    "_hsl": [
      0.17777777777777773,
      0.19230769230769224,
      0.3058823529411765
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Pathfinder.js